import React, { useState } from 'react';
import axios from 'axios';

const TutorInfoForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    subject: '',
    experience: '',
    email: '',
    phone: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post('api/tutors', formData);
      alert('Tutor data submitted successfully!');
      setFormData({
        name: '',
        subject: '',
        experience: '',
        email: '',
        phone: '',
      });
    } catch (err) {
      console.error(err);
      alert('Error submitting tutor data.');
    }
  };

  return (
    <section className="min-h-screen flex items-center justify-center bg-gradient-to-r from-purple-100 to-blue-200 py-16 px-6">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-8 rounded-3xl shadow-2xl w-full max-w-xl transition-all duration-500 hover:shadow-purple-300"
      >
        <h2 className="text-3xl font-bold text-center text-purple-700 mb-8">
          Tutor Information Form
        </h2>

        <div className="grid grid-cols-1 gap-5">
          <input
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Full Name"
            required
            className="w-full p-4 text-base border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
          />

          <input
            name="subject"
            value={formData.subject}
            onChange={handleChange}
            placeholder="Subject Expertise"
            required
            className="w-full p-4 text-base border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
          />

          <input
            name="experience"
            type="number"
            value={formData.experience}
            onChange={handleChange}
            placeholder="Years of Experience"
            required
            className="w-full p-4 text-base border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
          />

          <input
            name="email"
            type="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="Email Address"
            required
            className="w-full p-4 text-base border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
          />

          <input
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="Phone Number"
            required
            className="w-full p-4 text-base border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-purple-400"
          />

          <button
            type="submit"
            className="bg-purple-600 text-white font-semibold py-3 px-6 rounded-xl hover:bg-purple-700 transition-transform transform hover:scale-105"
          >
            Submit
          </button>
        </div>
      </form>
    </section>
  );
};

export default TutorInfoForm;
